var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmpyAlerts(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.398438,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#08C296"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.9171 12.0137H29.0968C28.8416 12.0137 28.5994 12.1309 28.4431 12.3314L17.7061 25.9329L12.5577 19.4095C12.4798 19.3106 12.3806 19.2307 12.2673 19.1756C12.1541 19.1206 12.0299 19.0919 11.9041 19.0918H10.0838C9.90928 19.0918 9.81292 19.2923 9.91969 19.4277L17.0525 28.4642C17.3858 28.8861 18.0265 28.8861 18.3624 28.4642L31.0811 12.347C31.1879 12.2142 31.0916 12.0137 30.9171 12.0137Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpyAlerts);
export default __webpack_public_path__ + "static/media/empyAlerts.81e929342794dcd8dd3110fe076d8bb4.svg";
export { ForwardRef as ReactComponent };